module.exports = __webpack_public_path__ + "media/images/sports_icons/swimming-0ca5fc3008f7ed8c5c98857986a23231.png";